export enum SearchFormValidation {
  proNumberNineValidation = 'proNumberNineValidation',
  proNumberTenValidation = 'proNumberTenValidation',
  proNumberElevenValidation = 'proNumberElevenValidation',
  proNumberLengthValidation = 'proNumberLengthValidation',
}
